import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { useLoader } from "../../../context/LoaderContext";
import { useNotification } from "../../../context/NotificationContext";
import AuthService from "../../../api/authService";

const fieldClassName =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-sm text-pixy-ink outline-none transition placeholder:text-slate-400 focus:border-pixy-blue focus:ring-2 focus:ring-pixy-blue/20";

export default function LoginForm({ onSwitch }) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const { showNotification } = useNotification();
  const { showLoader, hideLoader } = useLoader();
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    showLoader("form-wrapper");

    try {
      const res = await AuthService.login(formData);
      login(res.user);
      showNotification("success", "Connexion réussie.");
      navigate("/profile");
    } catch (error) {
      const message =
        error.response?.data?.error || "Email ou mot de passe incorrect.";

      if (message.includes("non verifie")) {
        setErrorMessage(
          "Ton compte n'est pas encore verifie. Tu peux renvoyer le lien d'activation."
        );
        showNotification(
          "warning",
          <>
            Ton compte n&apos;est pas verifie. Consulte ta boite mail ou{" "}
            <button
              onClick={() => onSwitch("resend")}
              className="ml-1 text-cyan-300 underline"
            >
              clique ici
            </button>{" "}
            pour recevoir un nouveau lien d&apos;activation.
          </>
        );
      } else {
        setErrorMessage(message);
        showNotification("error", message);
      }
    } finally {
      hideLoader();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="space-y-1">
        <label className="block text-sm font-semibold text-slate-700">
          Email
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="ton@email.com"
          className={fieldClassName}
        />
      </div>

      <div className="space-y-1">
        <div className="flex items-center justify-between gap-3">
          <label className="block text-sm font-semibold text-slate-700">
            Mot de passe
          </label>
          <button
            type="button"
            onClick={() => onSwitch("forgot")}
            className="text-xs font-semibold uppercase tracking-[0.2em] text-pixy-blue transition hover:text-pixy-green"
          >
            MOT DE PASSE OUBLIÉ ?
          </button>
        </div>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          placeholder="••••••••"
          className={fieldClassName}
        />
      </div>

      <label className="flex items-center gap-3 text-sm text-slate-600">
        <input
          type="checkbox"
          defaultChecked
          className="h-4 w-4 rounded border-slate-300 text-pixy-blue focus:ring-pixy-blue/20"
        />
        Rester connecté
      </label>

      {errorMessage && (
        <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {errorMessage}
        </div>
      )}

      <button
        type="submit"
        className="w-full rounded-2xl bg-gradient-to-r from-pixy-green to-pixy-blue px-4 py-3.5 text-sm font-bold uppercase tracking-[0.22em] text-white shadow-md shadow-sky-300/30 transition hover:-translate-y-0.5 hover:shadow-sky-300/50"
      >
        Se connecter
      </button>

      <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600">
        Pas encore de compte ?{" "}
        <button
          type="button"
          onClick={() => onSwitch("register")}
          className="font-semibold text-pixy-blue transition hover:text-pixy-green"
        >
          Créer un compte
        </button>
      </div>
    </form>
  );
}
